<template lang="pug">
  LayoutPlain
    .container
      .row.justify-content-center
        .col-lg-5.col-md-10
          .login--header.pad_b--20
            .login--logo: img(src='../assets/images/logo-auth.png')
            .login--tagline.align__center
              | eInvest Online Platform

          b-alert(variant='warning', :show="messages.error !== ''") {{ messages.error }}

          b-card
            .login--form
              .form-group
                label.text--color_grey.text-uppercase: small Email Address
                b-form-input(type='text', v-model='submit.username', autocomplete="on")

              .form-group
                label.text--color_grey.text-uppercase: small Password
                b-form-input(type='password', v-model='submit.password', v-on:keyup.enter="ATTEMPT_LOGIN", autocomplete="current-password")

              .mar_t--20
                button.button.button-primary.button_block(@click.prevent="ATTEMPT_LOGIN") Sign in

              .login--overlay(v-if="isLoading")

</template>



<script>
  export default {
    data() {
      return {
        submit: {
          username: '',
          password: '',
        },

        messages: {
          error: ''
        },

        redirectTo: null,
        isLoading: false,
      }
    },

    methods: {
      async ATTEMPT_LOGIN() {
        try {
          this.REQUEST_INIT();

          let response = await this.$axios.post('/login', {
            data: {
              type: 'login',
              attributes: {
                username: this.submit.username,
                password: this.submit.password,
              }
            }
          });

          this.GO_TO_AUTHENTICATION(response.data.token);

        } catch(error) {
          let _errorMessage = error.message || 'An error has occurred. Please try again later';

          if(error.response && error.response.status === 401) {
            _errorMessage = 'The credentials used is invalid';
          }

          this.messages.error = _errorMessage;

        } finally {
          this.REQUEST_FINALLY();

        }
      },

      REQUEST_INIT() {
        this.isLoading = true;
        this.messages.error = '';
      },

      REQUEST_FINALLY() {
        this.isLoading = false;
      },


      GO_TO_AUTHENTICATION(token) {
        if (token) {
          this.$router.replace({name: 'authenticate', query: { authToken: token, redirectTo: this.redirectTo } });
        }
      },

      SET_VALUES_FROM_QUERY() {
        let { redirectFrom, errorMessage } = this.$route.query;

        if(redirectFrom) {
          this.redirectTo = redirectFrom;
        }

        if(errorMessage) {
          this.messages.error = errorMessage;
        }
      }
    },

    created() {
      this.SET_VALUES_FROM_QUERY();
    },
  }

</script>




<style lang="scss" scoped>
  .login--logo {
    text-align: center;

    img {
      width: auto;
      height: 68px;
    }
  }
  .login--form {
    position: relative;
  }
  .login--overlay {
    position: absolute;
    top: -5px; bottom: -5px;
    left: -5px; right: -5px;
    background: rgba(255, 255, 255, 0.7);
  }

  .login--tagline {
    padding: 20px 0 10px;
    color: $color-primary;
    letter-spacing: 1px;
  } 
</style>
